import { SOLUTION_REFERENCE_TYPE } from './RetailerFitGuide_Constants.js';
export const getReferenceDataFromSolution = (solution, referenceTypeId) => {
  const reference = solution.SolutionComponents.find((x) => x.ReferenceTypeId?.toLowerCase() === referenceTypeId);
  return reference;
};

export const getReferenceDisplayNameById = (referenceTypeId) => {
  switch (referenceTypeId?.toLowerCase()) {
    case SOLUTION_REFERENCE_TYPE.RACKSOLUTION_BAR:
      return 'Bars';
    case SOLUTION_REFERENCE_TYPE.RACKSOLUTION_COMPLETE_FRONT:
      return 'Bars - front';
    case SOLUTION_REFERENCE_TYPE.RACKSOLUTION_COMPLETE_REAR:
      return 'Bars - rear';
    case SOLUTION_REFERENCE_TYPE.RACKSOLUTION_COMPLETE:
      return 'Bars - complete';
    case SOLUTION_REFERENCE_TYPE.RACKSOLUTION_KIT:
      return 'Kit';
    case SOLUTION_REFERENCE_TYPE.RACKSOLUTION_FOOT:
      return 'Foot';
    case SOLUTION_REFERENCE_TYPE.PLATFORM:
      return 'Platform';
    case SOLUTION_REFERENCE_TYPE.RACKSOLUTION_BASERAIL:
      return 'Base rail';
    case SOLUTION_REFERENCE_TYPE.RACKSOLUTION_OVERHEADRACK:
      return 'Overhead rack';
    case SOLUTION_REFERENCE_TYPE.SOLUTION_ADAPTER:
      return 'Adapter';
    case SOLUTION_REFERENCE_TYPE.RACKSOLUTION_TOWER:
      return 'Tower';
    default:
      return referenceTypeId;
  }
};

export const compareSolutions = (oldProductList, newProductList) => {
  let missingProducts = [];
  let reusedProducts = [];

  let ownedProducts = oldProductList.map((product) => ({ ...product, selected: false }));
  newProductList.forEach((component) => {
    let existing = ownedProducts.find((x) => x.ProductId === component.ProductId && !x.selected);

    if (existing) {
      reusedProducts.push(component);
      existing.selected = true;
    } else {
      missingProducts.push(component);
    }
  });
  const missingQuantity = missingProducts?.reduce((sum, item) => sum + item.Quantity, 0);

  return {
    missingQuantity: missingQuantity,
    missingProducts: missingProducts,
    reusedProducts: reusedProducts,
  };
};

export const getComparisonReference = (solutionComponents) => {
  if (!solutionComponents) return [];
  const grouped = solutionComponents.reduce((acc, item) => {
    const existingItem = acc.find((obj) => obj.ProductId === item.ProductId);
    if (existingItem) {
      existingItem.Quantity += 1;
    } else {
      acc.push({ ...item, Quantity: 1 });
    }
    return acc;
  }, []);
  return grouped;
};

export const getSolutionReferenceComponents = (solution) => {
  let list = [
    {
      Title: 'Fit kit',
      ...getReferenceDataFromSolution(solution, SOLUTION_REFERENCE_TYPE.RACKSOLUTION_KIT),
    },
    {
      Title: 'Foot',
      ...getReferenceDataFromSolution(solution, SOLUTION_REFERENCE_TYPE.RACKSOLUTION_FOOT),
    },
    {
      Title: 'Bars',
      ...getReferenceDataFromSolution(solution, SOLUTION_REFERENCE_TYPE.RACKSOLUTION_BAR),
    },
    {
      Title: 'Bars',
      ...getReferenceDataFromSolution(solution, SOLUTION_REFERENCE_TYPE.RACKSOLUTION_COMPLETE),
    },
    {
      Title: 'Bars',
      ...getReferenceDataFromSolution(solution, SOLUTION_REFERENCE_TYPE.RACKSOLUTION_COMPLETE_FRONT),
    },
    {
      Title: 'Bars',
      ...getReferenceDataFromSolution(solution, SOLUTION_REFERENCE_TYPE.RACKSOLUTION_COMPLETE_REAR),
    },
    {
      Title: 'Platform',
      ...getReferenceDataFromSolution(solution, SOLUTION_REFERENCE_TYPE.PLATFORM),
    },
    {
      Title: 'Base rail',
      ...getReferenceDataFromSolution(solution, SOLUTION_REFERENCE_TYPE.RACKSOLUTION_BASERAIL),
    },
    {
      Title: 'Overhead rack',
      ...getReferenceDataFromSolution(solution, SOLUTION_REFERENCE_TYPE.RACKSOLUTION_OVERHEADRACK),
    },
    {
      Title: 'Adapter',
      ...getReferenceDataFromSolution(solution, SOLUTION_REFERENCE_TYPE.SOLUTION_ADAPTER),
    },
    {
      Title: 'Tower',
      ...getReferenceDataFromSolution(solution, SOLUTION_REFERENCE_TYPE.RACKSOLUTION_TOWER),
    }
  ];
  return list.filter((x) => x.ReferenceTypeId);
};

export const IsVariationFactoryInstalledCrossbar = (variation) => {
  return (
    ['roof-type-617950', 'roof-type-651564', 'roof-type-651340', 'roof-type-651563'].find((x) => x === variation) !=
    null
  );
};

export const formatCurrency = (price, currencyCode) => {
  const formatter = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: currencyCode,
  });
  return formatter.format(price);
};

export const isValidSolutionType = (solutionType, includePlatform) => {
  let validTypes = ['Roof rack', 'Truck rack'];
  if (includePlatform) validTypes.push('Roof Platform');
  return validTypes.includes(solutionType);
};
